/* ===================================== */
/* SHARE BUTTON */
/* ===================================== */

document.addEventListener('click', function (e) {
  const btn = e.target.closest('.share-button');
  if (!btn) return;

  const data = { title: document.title, url: location.href };

  if (navigator.share) {
    navigator.share(data).catch(() => {});
  } else if (navigator.clipboard) {
    navigator.clipboard.writeText(location.href).then(() => {
      alert('Link copiado!');
    });
  }
});


/* ===================================== */
/* GLOBAL SHOPIFY DIALOG SCROLL FIX */
/* ===================================== */

(function () {

  const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  if (!isTouch) return;

  const DIALOG_SELECTOR = 'dialog[scroll-lock]';

  function restoreScroll() {

    const y = parseInt(document.body.dataset.scrollY || 0, 10);

    document.documentElement.style.overflow =
    document.body.style.overflow =
    document.body.style.position =
    document.body.style.top = '';

    document.body.classList.remove(
      'overflow-hidden',
      'modal-open',
      'js-modal-open'
    );

    if (y) {
      window.scrollTo(0, y);
      delete document.body.dataset.scrollY;
    }
  }

  function getOpenDialog() {
    return document.querySelector(`${DIALOG_SELECTOR}[open]`);
  }

  function closeDialog(dialog) {
    if (!dialog) return;
    if (dialog.hasAttribute('open')) dialog.close();
    restoreScroll();
  }

  /* Intercepta fechamento normal */
  document.addEventListener('close', function (e) {
    if (e.target.matches(DIALOG_SELECTOR)) {
      restoreScroll();
    }
  }, true);

  /* Observer único */
  const observer = new MutationObserver(() => {
    if (!getOpenDialog()) restoreScroll();
  });

  observer.observe(document.body, {
    subtree: true,
    attributes: true,
    attributeFilter: ['open']
  });

  /* Gesture back mobile */
  window.addEventListener('popstate', function () {
    const dialog = getOpenDialog();
    if (!dialog) return;
    closeDialog(dialog);
  });

})();



/* ===================================== */
/* MEGA MENU DELAY SUAVE – DESKTOP ONLY */
/* ===================================== */

document.addEventListener("DOMContentLoaded", function () {

  if (window.innerWidth < 990) return;

  const headerMenu = document.querySelector("header-menu");
  if (!headerMenu) return;

  let closeTimer = null;
  const delayTime = 250; // 🔥 mais curto agora

  const items = headerMenu.querySelectorAll(".menu-list__list-item");

  items.forEach(item => {

    const submenu = item.querySelector(".menu-list__submenu");
    if (!submenu) return;

    item.addEventListener("pointerenter", () => {
      clearTimeout(closeTimer);
    });

    item.addEventListener("pointerleave", () => {
      clearTimeout(closeTimer);

      closeTimer = setTimeout(() => {
        // 🔥 Apenas dispara o evento original do tema
        const event = new Event("pointerleave", { bubbles: true });
        item.dispatchEvent(event);
      }, delayTime);
    });

    submenu.addEventListener("pointerenter", () => {
      clearTimeout(closeTimer);
    });

  });

});




/* ===================================== */
/* TRADUZIR TEXTOS DO WISHLIST PLUS QUE APARECEM NA PÁGINA DO PRODUTO */
/* ===================================== */
(function() {

  function traduzirElemento(el) {
    if (!el) return;

    if (el.innerText.includes("Gostou?")) return;

    el.innerHTML = `
      Gostou? Clique no 
      <svg width="14" height="14" viewBox="0 0 24 24" style="display:inline-block;vertical-align:middle;margin-top:-2px;">
        <path d="M19.6706 5.4736C17.6806 3.8336 14.7206 4.1236 12.8906 5.9536L12.0006 6.8436L11.1106 5.9536C9.29063 4.1336 6.32064 3.8336 4.33064 5.4736C2.05064 7.3536 1.93063 10.7436 3.97063 12.7836L11.6406 20.4536C11.8406 20.6536 12.1506 20.6536 12.3506 20.4536L20.0206 12.7836C22.0706 10.7436 21.9506 7.3636 19.6706 5.4736Z" stroke="currentColor" stroke-width="1.75" fill="none"/>
      </svg>
      para salvar nos seus favoritos.
    `;
  }

  function traduzirBotao(btn) {
    if (!btn) return;

    if (btn.innerText === "Wishlist Now") {
      btn.innerText = "Salvar agora";
    }
  }

  function traduzirTudo() {
    const tooltip = document.querySelector('.swym-education-tooltip-message');
    const notificacao = document.querySelector('.swym-storefront-layout-notification-message');
    const botao = document.querySelector('.swym-storefront-layout-notification-action');

    traduzirElemento(tooltip);
    traduzirElemento(notificacao);
    traduzirBotao(botao);
  }

  // 🔥 loop leve pra garantir funcionamento com re-render do Swym
  setInterval(traduzirTudo, 400);

})();